<template>
    <div class="diagnose-list-section">
        <!-- 11诊断送诊 -->
        <van-row
            class="diagnose-list-section-box"
            @click="goDetail(dataItem)"
        >
            <div class="diagnose-list-section-left">
                <van-image
                    fit="cover"
                    class="diagnose-list-section-left-img"
                    :src="dataItem.content.cover_img"
                    width="100%"
                    height="100%"
                />
                <div class="diagnose-list-section-left-top" v-if="dataItem.top == 1">
                    <img src="/static/bytx/tag_top.svg" alt="" />
                </div>
                <div v-else class="diagnose-list-section-left-zl">
                    {{ dataItem.type_text }}
                </div>
            </div>
            <div class="diagnose-list-section-right">
                <div class="diagnose-list-section-right-title" v-html="dataItem.content.title"></div>
                <div class="diagnose-list-section-right-btn">
                    去查看 <img src="/static/bytx/list_more_icon.svg" alt="" />
                </div>
            </div>
            <div class="clear"></div>
            <div class="diagnose-list-section-info ellipsis-text">{{ dataItem.content.desc }}</div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
  methods: {
    goDetail(dataItem) {
      this.$router.push({ name: 'diagnose-detail', params: { id: dataItem.content.id } })
      Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
      Interface.mFootPrint(dataItem.id,67,this.contentType,1,0,0,0,dataItem.content.title, this.searchText)
    }
  }
}
</script>

<style lang="scss" scoped>
.diagnose-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-box {
        width: 345px;
        border-bottom: 1px solid #f2f2f2;
        padding-bottom: 0px;

        &:nth-last-child(1) {
            border: 0;
        }
    }

    &-left {
        width: 112px;
        height: 66px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 4px;
            left: 4px;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }
        }

        &-top {
            position: absolute;
            top: 4px;
            left: 4px;
            width: 18px;
            height: 18px;
            border-radius: 3px;
            img {
                width: 18px;
                height: 18px;
                border-radius: 3px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 219px;
        text-align: left;

        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            margin-top: 6px;

            text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;

            .light {
                color: #0fb7ad;
            }
        }

        &-btn {
            margin-top: 8px;
            font-family: PingFangSC-Regular;
            font-size: 13px;
            color: #0fb7ad;
            letter-spacing: 0;
            img {
                margin-bottom: -3px;
            }
        }
    }

    &-info {
        margin-top: 10px;
        background: #f1f2f4;
        border-radius: 6px;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: #79797d;
        letter-spacing: 0;
        padding: 8px;
        width: 315px;
    }

    .ellipsis-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/diagnose.vue